import { useIsAtLeastDesktopBreakpoint } from 'utils/hooks/media-queries';
import { BaseHomePageLinkProps } from './components/base-homepage-link';
import { PokerstarsHomepageLink } from './components/pokerstars-homepage-link';

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/

type HomePageLinkProps = BaseHomePageLinkProps;

/* -------------------------------------------------------------------------------------------------
 * component
 * -----------------------------------------------------------------------------------------------*/

const HomepageLink = (props: HomePageLinkProps) => {
  const isAtLeastDesktop = useIsAtLeastDesktopBreakpoint();

  const iconSize = props.iconSize ?? (isAtLeastDesktop ? '160px' : '114px');
  const iconHeight = props.iconHeight ?? (isAtLeastDesktop ? '28px' : '20px');
  return (
    <PokerstarsHomepageLink
      iconSize={iconSize}
      iconHeight={iconHeight}
      {...props}
    />
  );
};

export default HomepageLink;
